import { render, staticRenderFns } from "./MdGetLastAnswers.vue?vue&type=template&id=b0b2f3d2&"
import script from "./MdGetLastAnswers.vue?vue&type=script&lang=js&"
export * from "./MdGetLastAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports